module.exports = __webpack_public_path__ + "img/Logo-ikon.sort.c37f0e59.png";